var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',{attrs:{"col":"12","xl":"12"}},[_c('v-table',{attrs:{"id":"totalTable","columns":_vm.columns,"data":_vm.data,"options":_vm.options,"data-group-by":"true","data-group-by-field":"site_name"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }